
import { Vue, Component } from 'vue-property-decorator'
import BudgetGuardCodes from '@/views/budget/components/BudgetGuardCodes.vue'
import axios from 'axios'
import { GuardCodeWithBudgets } from '@/types/guardCodeWithBudgets'

interface Project {
  id:number
  reference:string
  name:string
}

interface TotalBudget {
  project:Project,
  guard_codes:GuardCodeWithBudgets[]
}

@Component({
  components: { BudgetGuardCodes }
})

export default class BudgetTotalsTab extends Vue {
  loading = false
  totalBudget:TotalBudget|null = null

  mounted () : void {
    this.getBudgetTotalBudgetInAfas()
  }

  getBudgetTotalBudgetInAfas () : void {
    this.loading = true
    axios.get(process.env.VUE_APP_API_URL + '/budgets/' + this.$route.params.projectId + '/totalInAfas').then((r) => {
      this.totalBudget = r.data
    }).catch(() => {
      console.log('Error')
    }).finally(() => {
      this.loading = false
    })
  }
}
